import ImportExportIcon from "@mui/icons-material/ImportExport";
const AscDescIcon = () => {
  return <ImportExportIcon className="icon" />;
};

export default AscDescIcon;
